/**
* 
*/
<template>
  <div>
    <el-button size="small" type="primary" class="title mb20" @click="addForm()">新增</el-button>
    <el-table size="small" :data="categoryList" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%">
      <el-table-column align="center" prop="ActivityTypeName" label="活动名称"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="text" @click="handleFrozen(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑界面 -->
    <el-dialog title="编辑" :visible.sync="editFormVisible" width="60%" @close="closeDialog()">
      <el-form label-width="120px" ref="editForm" :rules="rules" :model="editForm">
        <el-form-item label="活动名称" prop="ActivityTypeName">
          <el-input v-model="editForm.ActivityTypeName" maxlength="10" placeholder="不超过10个字"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title"
          @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      editFormVisible: false,
      loading: false,
      categoryList: [],
      rules: { ActivityTypeName: [{ required: true, message: '请输入类别名称', trigger: 'blur' }, { min: 1, max: 10, message: '长度不超过10个字符', trigger: 'blur' }] },
      editForm: {},
      activeIndex: 0
    }
  },
  mounted () {
    this.getData()
  },
  methods: {

    addForm () {
      this.editForm = {}
      this.editFormVisible = true;
    },

    getData () {
      let personInfo = JSON.parse(this.$util.getStore('personInfo'))
      let data = {
        CompanyGUID: personInfo.CompanyGUID
      };
      this.$loading()
      this.$api.QueryDataFn("ShopWebApp\\GetActivityTypeList_1_0_1&DBC=r_m", data).then(result => {
        this.$loading().close()
        if (result.data.OK != 'True') {
          this.$message({
            message: result.data.Message,
            type: 'success'
          });
        } else if (result.data.Tag.length <= 0) {

        } else {
          this.categoryList = result.data.Tag[0].Table;
        }
      })
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      if (!row.ActivityTypeGUID || row.ActivityTypeGUID == '') {
        this.editForm = {
          ActivityTypeGUID:'', 
          ActivityTypeName:''
        }
      } else {
        this.editForm = row
        this.activeIndex = index
      }
        this.editFormVisible = true
    },
    
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let { ActivityTypeGUID} = this.editForm;
          if(!ActivityTypeGUID||ActivityTypeGUID==''){
            this.$api.returnGuid().then(res => {
              this.editForm.ActivityTypeGUID=res;
              this.UpdateActivityType()
            })
          }else{
            this.UpdateActivityType()
          }
        } else {
          this.editFormVisible = false
        }
      });

    },
    UpdateActivityType () {
      let obj = this.editForm
      let sqlCmdName = 'ShopWebApp\\UpdateActivityType_1_0_1&DBC=w_m';
      let personInfo = JSON.parse(this.$util.getStore('personInfo'))
      let data = {
        CompanyGUID: personInfo.CompanyGUID,
        ActivityTypeGUID: obj.ActivityTypeGUID,
        ActivityTypeName: obj.ActivityTypeName
      }
      this.$loading()
      this.$api.ExSqlFn(sqlCmdName, data).then(res => {
        this.$loading().close()
        let result = res.data;
        if (result.OK != 'True') {
          this.$message(result.Message)
        } else {
          this.editFormVisible = false
          this.getData()
        }
      })
    },
    //显示删除界面
    handleFrozen: function (index, row) {
      console.log(index, row, 93)
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delete(row.ActivityTypeGUID)
      });
    },
    delete (e) {
      this.$loading();
      this.$api.ExSqlFn('ShopWebApp\\DeleteActivityType_1_0_1&DBC=w_m', { ActivityTypeGUID: e }).then((res) => {
        this.$loading().close()
        let result = res.data;
        if (result.OK != 'True') {
          this.$message(result.Message)
        } else {
          this.$message('删除成功');
          this.getData()
        }
      })

    },
  }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/views/shop/addActiveCategorize.vue